<template>
  <div
    :class="$style.container"
    data-sb-regression="sb-filter-options"
  >
    <div :class="$style.filterOptionContainer">
      <sb-button
        v-tooltip.top="$t('sbFilter.filterTooltip')"
        :icon="'pi ' + (isHovering ? 'pi-filter-fill' : 'pi-filter')"
        variation="iconOnly"
        data-sb-automation="filter-bar-open-filter-selection"
        @mouseover="applyFilterMouseOver"
        @mouseleave="applyFilterMouseOut"
        @click="openFilterSelection(true)"
      />
      <sb-badge
        v-show="appliedFilterCount > 0"
        size="extra-small"
        data-sb-automation="filter-count"
        :class="$style.filterButtonBadge"
      >
        {{ appliedFilterCount }}
      </sb-badge>
    </div>
    <sb-button
      v-tooltip.top="$t('sbFilter.columnsTooltip')"
      :icon="ColumnsIcon"
      variation="iconOnly"
      data-sb-automation="filter-bar-open-column-selection"
      @click="openColumnSelection(true)"
    />
    <slot name="options" />
  </div>
  <ColumnsDrawer
    v-model:active="colSelectionActive"
    :column-definitions="columnDefinitions"
    :applied-columns="initialValues.savedColumns"
    @update:applied-columns="updateColumnSelection"
  />
  <FiltersDrawer
    v-model:active="filterSelectionActive"
    :filter-definitions="filters"
    :applied-filters="initialValues.savedFilters"
    @update:applied-filters="updateFilterSelection"
  />
</template>

<script setup>
import { computed, defineOptions, ref, watch, defineEmits, defineProps } from 'vue';
import SbBadge from '@src/components/Badge/SbBadge.vue';
import SbButton from '@src/components/Button/SbButton.vue';
import ColumnsIcon from '@public/media/icons/columns.svg';
import get from 'lodash/get';
import ColumnsDrawer from '@src/components/Filter/next/components/SbColumnsDrawer.vue';
import FiltersDrawer from '@src/components/Filter/next/components/SbFiltersDrawer.vue';

const isHovering = ref(false);

const applyFilterMouseOver = () => {
  isHovering.value = true;
};
const applyFilterMouseOut = () => {
  isHovering.value = false;
};

const colSelectionActive = ref(false);
const filterSelectionActive = ref(false);

const emit = defineEmits(['change-column-selection', 'change-filter-selection']);
const props = defineProps({
  columnDefinitions: {
    type: Array,
    default: () => [],
  },
  filters: {
    type: Array,
  },
  initialValues: {
    type: Object,
    default: () => ({}),
  },
});
const appliedFilterCount = ref(0);

defineOptions({
  name: 'SbFilterOptions',
});
function openColumnSelection(value) {
  colSelectionActive.value = value;
}
function openFilterSelection(value) {
  filterSelectionActive.value = value;
}
function updateFilterSelection(value) {
  appliedFilterCount.value = Object.keys(value || {}).length;
  emit('change-filter-selection', { ...value });
}
function updateColumnSelection(value) {
  emit('change-column-selection', value);
}
const filterKeys = computed(() => {
  return props.filters?.reduce((prev, curr) => {
    const object = prev;
    object[curr.key] = 1;
    return object;
  }, {}) || {};
});
watch(() => props.initialValues?.savedFilters, (newValue) => {
  if (newValue) {
    appliedFilterCount.value = Object.keys(newValue).filter((key) => !!filterKeys.value[key]).length;
    return;
  }
  appliedFilterCount.value = 0;
}, { immediate: true });

</script>

<style lang='scss' module>
@use '@src/components/Filter/next/styles/sbFilterOptions.module.scss';
</style>
